<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />

			<div class="flex justify-between items-end mt-3">
				<div class="flex items-end">
					<h3 class="font-bold">{{models.name}}</h3>
					<span class="text-primary ml-3 font-bold">{{models.tier && models.tier.name}}</span>
				</div>
			</div>
			<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
				<div class="w-full lg:w-4/12 border-solid border-0 border-grey lg:border-r">
					<div class="field">
						<div class="flex items-center">
							<div class="w-48 h-32 mr-3">
								<img class="h-full w-full object-cover bg-grey rounded-lg" :src="getUrlOfFile(models.image)" alt="image-product">
							</div>
							<div class="description">
								<a class="text-base">{{models.email}}</a>
								<p class="text-base my-1">Birth date: {{models.bod ? moment(models.bod).format('DD-MMM-YYYY') : '-'}}</p>
								<p class="text-base mb-1">{{contentTypes}}</p>
                                <vs-divider />
								<p v-if="models.communities" class="text-base mb-1">
									<strong>Community</strong>:
									<template v-if="models.communities.length">
										<template v-for="v in models.communities">
											{{v.community ? v.community.name : "-"}}
										</template>
									</template>
									<template v-else>
										-
									</template>
								</p>
								<p class="text-base my-1 font-bold" :class="[ isVerified === false || isBanned || isSuspend ? 'text-danger' : isVerified === true ? 'text-success' : 'text-warning']">{{isVerifiedText}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="w-full lg:w-3/12 flex flex-col justify-evenly border-solid border-0 border-grey lg:border-r my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Address</label>
						<p class="text-base font-bold">{{models.address || '-'}}{{models.province && `, ${models.province}`}}</p>
					</div>
					<div class="field">
						<label class="text-base">Phone Number</label>
						<p class="text-base font-bold">{{models.phoneNumber || '-'}}</p>
					</div>
				</div>
				<div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0 border-solid border-0 border-grey lg:border-r">
					<div class="field">
						<label class="text-base">Date of Joined</label>
						<p class="text-base font-bold">{{models.dateJoined ? moment(models.dateJoined).format('DD MMMM YYYY') : '-'}}</p>
					</div>
					<div class="field">
						<label class="text-base">Last Activity</label>
						<p class="text-base font-bold">{{models.dateJoined ? moment(models.lastActive).format('DD MMMM YYYY HH:mm') : '-'}}</p>
					</div>
				</div>
				<div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Point Withdraw</label>
						<p class="text-base font-bold">{{models.totalPoint}}</p>
					</div>
					<div class="field">
						<label class="text-base">Point Balance</label>
						<p class="text-base font-bold">{{models.totalCash}}</p>
					</div>
				</div>
			</div>
			<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
                <div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Suspend By</label>
						<p class="text-base font-bold">{{models.suspendBy || "-"}}</p>
					</div>
					<div class="field">
						<label class="text-base">Suspend At</label>
						<p class="text-base font-bold">{{models.suspendAt ?  moment(models.suspendAt).format('DD MMMM YYYY') : "-"}}</p>
					</div>
                    <div class="field">
						<label class="text-base">Suspend Reason</label>
						<p class="text-base font-bold">{{models.suspendReason || "-"}}</p>
					</div>
				</div>
            </div>

			<vs-divider />

			<section v-for="(socmed, index) in models.socialMedia" :key="index" :id="socmed.socialMedia" class="social-media">
				<h4 class="font-semibold capitalize">{{socmed.socialMedia}}</h4>
				<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
					<div class="w-full lg:w-4/12 border-solid border-0 border-grey lg:border-r flex items-center">
						<div class="description">
							<h6>{{renderTextPLatform('username', socmed.socialMedia)}}:</h6>
							<h6 class="text-sm my-1 font-bold"><span v-if="['instagram', 'tiktok', 'twitter', 'lemon8', 'threads', 'shopee'].includes(socmed.socialMedia) && !socmed.username.includes('@')">@</span>{{socmed.username}}</h6>
						</div>
					</div>
					<div class="w-full lg:w-8/12 lg:px-5 flex flex-wrap md:flex-no-wrap md:flex-row mt-2 lg:mt-0">
						<div v-if="socmed.follower" class="w-6/12 grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">{{renderTextPLatform('followers', socmed.socialMedia)}}</h6>
								<p class="text-lg font-bold">{{socmed.follower || 0}}</p>
							</div>
						</div>
						<div v-if="socmed.engagement" class="w-6/12 grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">Engagement</h6>
								<p class="text-lg font-bold">{{socmed.engagement || 0}}%</p>
							</div>
						</div>
						<div v-if="socmed.link" class="w-full grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">Link</h6>
								<a class="text-lg font-bold" :href="socmed.link" target="_blank">{{socmed.link}}</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- Button Action -->
			<div class="md:w-3/4 mt-20 flex justify-between flex-col md:flex-row m-auto">
				<vs-button class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" color="rgb(172,172,172)" type="filled" @click="$router.push('/request-unsuspend')">Back</vs-button>
                <vs-button class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" color="success" type="filled" @click="openApproveModal">Approve</vs-button>
			</div>
		</vs-card>
        <vs-popup classContent="popup-example"  title="Input Reason" :active.sync="modalReason">
            <vs-textarea label="Reason" v-model="reason" rows="3"/>
            <vs-button button="button" @click="approve" color="primary" type="filled" class="mr-3">Save</vs-button>
        </vs-popup>
	</form>
</template>

<script>
	import {getUrlOfFile} from '@/utils/helpers'
	import moment from 'moment'
	import api from '@/utils/api'
	export default {
		name: 'DetailReqUnsuspend',
		data() {
			return {
				getUrlOfFile,
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: '',
					email: '',
					bod: '',
                    communities: [],
					contentTypes: [],
					address: '',
					province: '',
					phoneNumber: '',
					dateJoined: '',
					lastActive: '',
					totalCash: '',
					totalPoint: '',
					socialMedia: [],
					isBanned: false,
					isSuspend: false,
					isVerified: null,
					isActive: true
				},
				moment,
                modalReason: false,
                reason: "",
			}
		},
		computed: {
			isVerifiedText() {
				return this.isSuspend ? 'Suspend' : this.isBanned ? 'Banned' : this.models.isVerified === true ? 'Approved' : this.models.isVerified === false ? 'Rejected' : 'Waiting Approval'
			},
			isActive() {
				return this.models.isActive
			},
			isVerified() {
				return this.models.isVerified
			},
			isSuspend() {
				return this.models.isSuspend
			},
			isBanned() {
				return this.models.isBanned
			},
			contentTypes() {
				return this.models.contentTypes.map(content => content.name).join(', ')
			},
		},
		created() {
			this.getAmbassador()
			if(this.$route.params.fromCampaign) {
				this.config.fromCampaign = this.$route.params.fromCampaign
			}
		},
		methods: {
			getAmbassador() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.brandAmbasador}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
                            this.models.id = data.id;
							this.models.name = data.name;
							this.models.image = data.image;
							this.models.community = data.community;
							this.models.bod = data.bod;
							this.models.tier = data.tier;
							this.models.email = data.balance.email;
							this.models.socialMedia = data.socialMedia;
							this.models.contentTypes = data.contentTypes;
							this.models.address = data.address;
							this.models.province = data.province;
							this.models.phoneNumber = data.balance.phoneNumber;
							this.models.dateJoined = data.balance.dateJoined;
							this.models.lastActive = data.balance.lastActive;
							this.models.totalPoint = data.balance.totalPoint;
							this.models.totalCash = data.balance.totalCash;

							this.models.isVerified = data.isVerified;
							this.models.isSuspend = data.isSuspend;
							this.models.isBanned = data.isBanned;
							this.models.isActive = data.account.isActive;
                            this.models.suspendReason = data.suspendReason;
                            this.models.suspendBy = data.suspendBy;
                            this.models.suspendAt = data.suspendAt;
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			renderTextPLatform(type, data) {
				const socmed = data.toLowerCase()
				if(type === 'username') {
					if(socmed === 'youtube') {
						return 'Channel'
					} else {
						return 'Username'
					}
				} else {
					if(['instagram', 'tiktok', 'twitter', 'lemon8', 'threads'].includes(socmed)) {
						return 'Followers'
					} else if (socmed === 'facebook') {
						return 'Friends'
					} else {
						return 'Subscibers'
					}
				}
			},
            openApproveModal(){
                this.modalReason = true;
                this.reason = '';
            },
			approve() {
                const _ = this;
                this.modalReason = false;
				this.$axios.patch(`${api.brandAmbasador}/${_.models.id}/suspend`,{
                            status: false,
                            reason: _.reason
                        })
						.then(res => {
							this.$refs.response.setResponse(res.data, 'success');
							this.$router.push('/request-unsuspend');
						})
						.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
			},
		}
	}
</script>
